/**
 * Size chart open/close for PDP and cart quick-view.
 * Event delegation so buttons work after AJAX-injected quickview HTML.
 * Moves the popup to document.body so position:fixed is not trapped
 * by the quickview modal transform.
 */
(function () {
  if (window.__tmnSizeChartBound) return;
  window.__tmnSizeChartBound = true;

  function openSizeChart(modal) {
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.classList.add('is-open');
    modal.style.display = 'flex';
    document.body.classList.add('size-chart-open');
  }

  function closeSizeChart(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.style.display = 'none';
    document.body.classList.remove('size-chart-open');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-tmn-size-chart-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      var modalId = openBtn.getAttribute('data-tmn-size-chart-open');
      openSizeChart(document.getElementById(modalId));
      return;
    }

    var closeBtn = e.target.closest('[data-tmn-size-chart-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeSizeChart(closeBtn.closest('.size-chart-modal'));
      return;
    }

    if (e.target.classList && e.target.classList.contains('size-chart-modal')) {
      closeSizeChart(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModal = document.querySelector('.size-chart-modal.is-open');
    if (openModal) closeSizeChart(openModal);
  });
})();
